export default {
  unix() {
    return +((+new Date()).toString().substring(0, 10));
  },
};



// WEBPACK FOOTER //
// ./src/utils/date.js